import {
  API_MSP_V2,
  storageProviderNameToId,
  API_MSP_LIST_V2,
  PAGE_SIZE,
} from "consts";
import { AxiosInstance } from "axios";
import withUrlParams from "utils/withUrlParams";
import { IGetMSPList, IMsp } from "types/apis/msp.types";
import { updateMspStatus } from "utils/formatter";

interface IGetMspDetailsParams {
  httpClient: AxiosInstance;
  mspId: string;
}

export const getMspDetails = async ({
  httpClient,
  mspId,
}: IGetMspDetailsParams) =>
  httpClient
    .get<IMsp>(withUrlParams(API_MSP_V2, { mspId }))
    .then(interceptMspDetails);

export const interceptMspDetails: (mspDetails: IMsp) => IMsp = (mspDetails) => {
  if (!mspDetails.products) {
    mspDetails.products = [];
  }
  mspDetails.products.forEach((product) => {
    product.awsStorageRegions = product.storageRegions
      .filter(
        ({ storageProvider }) => storageProvider === storageProviderNameToId.aws
      )
      .map(({ name }) => name);
    product.azureStorageRegions = product.storageRegions
      .filter(
        ({ storageProvider }) =>
          storageProvider === storageProviderNameToId.azure
      )
      .map(({ name }) => name);
  });

  return updateMspStatus(mspDetails);
};

interface IGetMspListParams {
  httpClient: AxiosInstance;
  pageParam: string;
}

export const getMspList = async ({
  httpClient,
  pageParam,
}: IGetMspListParams) => {
  const { mspList, nextPageToken } = await httpClient.get<IGetMSPList>(
    API_MSP_LIST_V2,
    {
      params: pageParam
        ? { pageToken: pageParam }
        : { pageSize: PAGE_SIZE, includeDetails: true },
    }
  );

  return {
    data: mspList,
    pageParam: nextPageToken,
  };
};
